import { ApolloClient, ApolloProvider, InMemoryCache, DefaultOptions } from '@apollo/client';
import config from '@saucelabs/sl-util-config';
import React, { useMemo } from 'react';

// Setup env var for
const defaultOptions: DefaultOptions = {
  watchQuery: {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
  },
  mutate: {
    errorPolicy: 'all',
  },
};

const ApolloWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  const client = useMemo(() => (new ApolloClient({
    uri: config.apiBaseUrls.iris,
    cache: new InMemoryCache({
      typePolicies: {
        User: {
          fields: {
            // Parse User.id as a UUID without hashes to match the User service's default return
            // types
            id: (id: string) => id.replace(/-/g, ''),
          },
        },
      },
    }),
    defaultOptions,
    name: 'frontend',
    assumeImmutableResults: true,
    connectToDevTools: true,
    credentials: 'include',
    headers: {
      'x-requested-with': 'apollo-client',
    },
  })), []);
  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

export default ApolloWrapper;
